import { render, staticRenderFns } from "./cardEdit.vue?vue&type=template&id=589b89b3&scoped=true&"
import script from "./cardEdit.vue?vue&type=script&lang=js&"
export * from "./cardEdit.vue?vue&type=script&lang=js&"
import style0 from "./cardEdit.vue?vue&type=style&index=0&id=589b89b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b89b3",
  null
  
)

export default component.exports